<template>
  <div class="live-watch">
    <!-- <button class="btn" @click="stopWatch">홈으로</button> -->

    <video
      id="liveWatch"
      class="video mx-auto d-block"
      autoplay
      controls>
    </video>
    <video-controls v-on:setVideoQulity="onSetVideoQulity">
    </video-controls>
  </div>
</template>

<script>
import VideoControls from '@/components/live/VideoControls'
import { mapState } from 'vuex'
import Remon from '@remotemonster/sdk'
import { remonDefaultConfig as rtcDefaultConfig } from '@/config'
import l from '@/vendor/logger'

let remon

export default {
  name: 'WatchLive',

  created () {
    window.onbeforeunload = this.stopWatch
  },

  mounted () {
    this.watchLive()
  },

  beforeDestroy () {
    window.onbeforeunload = null
    if (remon) { this.stopWatch() }
  },

  data () {
    return {
      msg: null,
      videoStyle: null
    }
  },

  computed: {
    ...mapState('room', [
      'room',
      'type'
    ])
  },

  watch: {
    rid (newRid, oldRid) {
      l.d('LiveWatch/watch/watch_room_changed', newRid, oldRid)
      if (this.type === 'WATCH') {
        this.stopWatch()
      }
      this.watchLive()
    },
    type (newType, oldType) {
      if (newType !== 'WATCH') {
        this.stopWatch()
      }
    }
  },

  methods: {
    stopWatch (event) {
      l.d('WatchLive/stopWatch')
      if (remon) {
        remon.close()
        remon = null
        l.d('WatchLive/stopWatch/remon_removed', remon)
      }
      this.$store.dispatch('room/clearRoom')
      this.$router.push({ name: 'home' })
    },
    watchLive () {
      const vm = this
      const rtcConfig = {
        ...rtcDefaultConfig,
        view: { remote: '#liveWatch' },
        media: {
          audio: true,
          video: {
            width: { exact: '640' },
            height: { exact: '480' }
          },
          recvonly: true
        }
      }
      const rtcListener = {
        onJoin (chId) {},
        onClose () {
          vm.stopWatch()
        },
        onError (e) {
          l.e('WatchLive/remon/onError', e)
          vm.stopWatch()
        },
        onStateChange (state) {
          l.d('WatchLive/remon/onStateChange', state)
        }
      }
      remon = new Remon({ config: rtcConfig, listener: rtcListener })
      // FIXME: room.chId get before bind room. I think..
      setTimeout(() => {
        remon.joinCast(this.room.chId)
      }, 2000)
    },
    onSetVideoQulity (qulity) {
      return remon
        ? remon.setVideoQulity(qulity)
        : l.e('WatchLive:setVideoQulity:remon_not_exist', qulity)
    }
  },
  components: {
    VideoControls
  }
}
</script>

<style scoped>
.live-watch {
  & .video {
    background-color: black;
    width: 640px;
    height: 480px;
  }
}
</style>
